import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import { API, graphqlOperation } from "aws-amplify";
import { default as React, useReducer, useState } from "react";
import translate from "../../../i18n/translate";
import { CancelSessionTMS } from "../../../queries";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import Toaster from "../../shared/Toaster/Toaster";
import "./MyScheduleSummaryBlock.scss";
import { useSelector, useDispatch } from "react-redux";
import allActions from "../../../redux/actions";


const CancelPopup = (props: any) => {
    const allInfo = useSelector((state: any) => state);
    const dispatch = useDispatch();
    const [open, setOpen] = useState(props.openCancel);
    const [status, setstatus] = useState(0);
    const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
      toastOpen: false,
      toastSeverity: "error",
      toastMessageKey: "",
    });
  
    const handleToastOptionsDirect = (name: string, val: any) => {
      settoastOptions({ [name]: val });
    }
  
    const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
      handleToastOptionsDirect("toastSeverity", severity);
      handleToastOptionsDirect("toastMessageKey", messageKey);
      handleToastOptionsDirect("toastOpen", open);
    };
    const handleClose = () => {
      setOpen(false);
      props.setCancelPopUp(false);
    };
  
    const CancelOnCLick = (setJoinNow: any, isLatestCancel: boolean) => {
  
      const learnerToken = sessionStorage.getItem("jwToken");
      const sessionId: string = props.cancelProps.SessionId;
      const cancelSession = API.graphql(graphqlOperation(CancelSessionTMS, { learnerToken, sessionId })) as Promise<any>;
      cancelSession.then((data: any) => {
        setOpen(false);
        props.setCancelPopUp(false);
  
        if (!allInfo.createSessionService.isLoading) {
          dispatch(allActions.createSessionServiceAction.createSessionService(Number(sessionStorage.getItem("courseId"))));
        }
        if (!allInfo.tmsLearnerSessions.isLoading) {
          dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
        }
        if (isLatestCancel) {
          setJoinNow(false);
        }
        toasterHandle(true, "success", "message_welcomeSubmitted");
      },
        (error) => (err: Error) => {
          toasterHandle(true, "error", "message_errorDefault");
          setstatus(sessionStorage.getItem("isScheduleRequired") !== "true" ? 401 : 1);
        });
    };
  
    return status === 0 ? (
      <Dialog
        className="cancel-session-dialog"
        open={props.openCancel}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="jss1581" id="alert-dialog-title">
          {translate("myschedule_cancel_question")}
          <CloseIcon  data-testid="close-button-ID"  className="closeButton" onClick={handleClose}></CloseIcon>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix"></div>
            <div data-testid="cancel-session-popup-ID"  id="cancel-session-popup" className="ui-dialog-content ui-widget-content">
              <div id="cancelSessionData">
                <div className="cancel-schedule-details">
                  <span>{props.cancelProps.CoachName}</span>
                  <span>{props.cancelProps.Session_GetstartDate}</span>
                  <span>{props.cancelProps.StartTime}</span>
                  <span>{props.cancelProps.DurationMins} {translate("myschedule_sessionDuraion_minutes")}</span>
  
  
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="session-cancel-buttons">
            <Button
              size="medium"
              className="button session cancel"
              onClick={() => handleClose()}
              id="skip-page"
              tabIndex={0}
            >
              <span>
                <span>{translate("myschedule_cancel_no")}</span>
              </span>
              <span className="jss1631"></span>
            </Button>
            <Button
              color="primary" variant="contained" size="medium"
              data-testid="intercept-next-button-ID"
              onClick={() => CancelOnCLick(props.setJoinNow, props.isLatestCancel)}
              id="intercept-next-button"
              tabIndex={0}
              className="next-intercept-page-button"
            >
              <span className="jss1639">
                <span>{translate("myschedule_cancel_button")}</span>
              </span>
              <span className="jss1667"></span>
            </Button>
          </div>
        </DialogActions>
  
      </Dialog>
  
    ) : (
      <Dialog
        className="cancel-session-dialog"
        open={props.openCancel}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <ErrorPage status={status}></ErrorPage>
        <Toaster
          open={toastOptions.toastOpen}
          severity={toastOptions.toastSeverity}
          toasterClosed={toasterHandle}
          messageKey={toastOptions.toastMessageKey}
        />
  
      </Dialog>
    );
  };


  export default CancelPopup;